<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-29 13:48:09
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-14 16:51:56
 * @FilePath: /dsicm-admin-web/src/views/newPatientmanage/components/UserDetails/userLeft.vue
-->
<template>
    <div class="user-details">
        <div class="top">
            <strong>个人基本信息</strong>
            <div class="btn" @click="isEdit = !isEdit" v-if="!isEdit">
                <i class="el-icon-edit"></i>
                <p>编辑</p>
            </div>
            <div class="btn" @click="submitHandel" v-else>
                <i class="el-icon-edit"></i>
                <p>保存</p>
            </div>
        </div>
        <aside>
            <span v-show="false">{{getUserDetailsData}}</span>
            <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
                  <el-form 
                  :model="ruleForm" 
                  :rules="rules"
                  size="mini"
                  ref="ruleForm" 
                  label-width="107px" 
                  label-position="left"
                 >
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="姓名:">
                                <p>{{ruleForm.patientName}}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="性别:">
                                <p>{{ruleForm.sex == 1 ? '男' :'女'}}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="年龄:">
                                <p>{{ruleForm.age}}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="血型:">
                                <p v-if="!isEdit">{{ruleForm.bloodType | bloodTypeFilt}}</p>
                                <el-select v-model="ruleForm.bloodType" v-else>
                                    <el-option 
                                    :label="item.label" 
                                    :value="item.value" 
                                    v-for="(item,index) in bloodTypeList" 
                                    :key="index">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="民族:">
                                <p>{{ruleForm.nation}}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="籍贯:">
                                <p>{{ruleForm.nativePlace}}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="当前居住地址:">
                            <p>{{ruleForm.province}}{{ruleForm.city}}{{ruleForm.county}}{{address}}</p>
                        </el-form-item>
                        </el-col>
                        
                        <el-col :span="12">
                            <el-form-item label="出生日期:">
                                <p>{{ruleForm.birthday}}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12" v-if="ruleForm.sex == 2">
                            <el-form-item label="是否孕产妇:">
                                <p v-if="!isEdit">{{ruleForm.pregnancyStatus == 1 ? '是' : '否'}}</p>
                                <el-select 
                                v-model="ruleForm.pregnancyStatus" v-else>
                                    <el-option 
                                    v-for="(item,index) in pregnancyStatusList"
                                    :key="index"
                                    :label="item.label" 
                                    :value="item.value" >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="职业:">
                                <p>{{ruleForm.occupation}}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="体力劳动等级:">
                                <p v-if="!isEdit">{{ruleForm.labour | labourFilte}}</p>
                                <el-select v-model="ruleForm.labour" placeholder="请选择活动区域" v-else>
                                    <el-option 
                                    v-for="(item,index) in labourTypeList"
                                    :key="index"
                                    :label="item.label" 
                                    :value="item.value" >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="证件类型:">
                                <p>{{ruleForm.certificate}}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="证件号码:">
                                <p>{{ruleForm.idCard}}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系方式:">
                                <p>{{ruleForm.mobile}}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    

                    <el-row :gutter="20" v-if="ruleForm.pregnancyStatus == 1">
                        <el-col :span="12">
                            <el-form-item label="末次月经:" >
                                <p v-if="!isEdit">{{ruleForm.lastMenstrualPeriod}}</p>
                                <el-date-picker
                                v-else
                                style="width:172px"
                                :picker-options="lastMenstrualPeriodPickerOptions"
                                value-format="yyyy-MM-dd"
                                :clearable="false"
                                v-model="ruleForm.lastMenstrualPeriod"
                                type="date"
                                placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="预产期:" >
                                <p v-if="!isEdit">{{ruleForm.predictChildbirth}}</p>
                                <el-date-picker
                                v-else
                                v-model="ruleForm.predictChildbirth"
                                value-format="yyyy-MM-dd"
                                :picker-options="predictChildbirthPickerOptions"
                                :clearable="false"
                                style="width:172px"
                                type="date"
                                placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" v-if="ruleForm.pregnancyStatus == 1">
                        <el-col :span="12">
                             <el-form-item label="胎数:">
                                <p v-if="!isEdit">{{ruleForm.embryoNumber | embryoNumberFilte}}</p>
                                <el-select v-model="ruleForm.embryoNumber" v-else>
                                    <el-option 
                                    v-for="(item,index) in embryoNumberList"
                                    :key="index"
                                    :label="item.label" 
                                    :value="item.value" >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="孕前BMI(kg/m²):">
                                <p>{{ruleForm.pregnancyBmi}}</p>
                            </el-form-item>
                        </el-col>
                        
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="当前体重(kg):" >
                                <p v-if="!isEdit">{{ruleForm.weight}} </p>
                                <el-input v-model.number="ruleForm.weight" style="width:172px" v-else></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="当前身高(cm):">
                                <p v-if="!isEdit">{{ruleForm.height}}</p>
                                <el-input v-model.number="ruleForm.height" style="width:172px" v-else></el-input>
                            </el-form-item>
                        </el-col>
                        
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="理想体重(IBW):">
                                <p>{{ruleForm.ibw}}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="当前体重占理想体重(%):">
                                <p>{{ruleForm.weightIbm}}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="BMI(kg/m²):">
                                <p>{{ruleForm.bmi}}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="腰臀比:">
                                <p>{{ruleForm.whr}}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="腰围(cm):">
                                <p>{{ruleForm.waistline}}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="臀围(cm):">
                                <p>{{ruleForm.hipline}}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20"  v-if="ruleForm.pregnancyStatus == 1"> 
                        <el-col :span="12">
                            <el-form-item label="孕周:" >
                                <p v-if="!isEdit">{{ruleForm.gestationalWeeks | gestationalWeeksFilts}}</p>
                                <el-select v-model="ruleForm.gestationalWeeks" v-else>
                                    <el-option 
                                    v-for="(item,index) in gestationalWeeksList"
                                    :key="index"
                                    :label="item.label" 
                                    :value="item.value" >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="孕前体重(kg):" >
                                <p v-if="!isEdit">{{ruleForm.pregnancyWeight}}</p>
                                <el-input v-model.number="ruleForm.pregnancyWeight" style="width:172px" v-else></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="基础代谢(kcal):">
                                <p>{{ruleForm.kcal}}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="营养风险:">
                                <p>{{ruleForm.nutritionalRisk}}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-form>
            </el-scrollbar>
        </aside>
    </div>
</template>

<script>
import {UpdatepatientArchiesLeft} from '../../api'
export default {
    name:'UserDetails',
    props:{
        userDetailsData:{
            type:Object,
            default:()=>{}
        }
    },
    data(){
        return{
            predictChildbirthPickerOptions: {//禁用当前日之前的时间
                disabledDate(time) {
                    return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                },
            } ,     
            lastMenstrualPeriodPickerOptions: {//只能选当天日期之前的
                disabledDate(time){
                    return time.getTime() >= Date.now() - 24 * 60 * 60 * 1000;
                }
            },
			address: '',
            ruleForm:{
                patientName:'',//姓名
                sex:'',//性别 1男 2女
                age:'',//年龄
                bloodType:'',//血型
                nation:'',//民族
                nativePlace:'',//籍贯
                maritalStatus:'',//1 已婚 2 未婚
                birthday:'',//出生日期
                pregnancyStatus:'',//是否孕妇 1是 2否
                occupation:'',//职业
                labour:'',//体力劳动等级 1轻体力劳动 2 中等体力劳动 3重体力劳动 4极重体力劳动
                certificate:'',//证件类型 未知枚举
                idCard:'',//证件号码
                mobile:'',//	联系方式
                address:'',//	当前居住地址
                 province:'',//省
                city:'',//市
                county:'',//区
                lastMenstrualPeriod:'',//末次月经	
                predictChildbirth:'',//预产期	
                embryoNumber:'',//胎数 1 单胎 2 双胎 3 多胎	
                height:'',//当前身高	
                weight:'',//当前体重	
                pregnancyWeight:'',//孕前体重	
                ibw:'',//理想体重	
                weightIbm:'',//当前体重占理想体重	
                bmi:'',//BMI
                pregnancyBmi:'',//孕前BMI	
                waistline:'',//腰围	
                hipline:'',//臀围	
                gestationalWeeks:'',//孕周	
                whr:'',//腰臀比	
                kcal:'',//基础代谢	
                nutritionalRisk:'',//营养风险:
                id:'',
            },
            rules:{
                bloodType: [
                    { required: true, message: '请选择血型', trigger: 'change' }
                ],
                pregnancyStatus: [
                    { required: true, message: '请选择是否孕产妇', trigger: 'change' }
                ],
                labour:[
                    { required: true, message: '请选择体力劳动等级', trigger: 'change' }
                ],
                lastMenstrualPeriod:[
                    { required: true, message: '请选择末次月经时间', trigger: 'change' }
                ],
                predictChildbirth:[
                    { required: true, message: '请选择预产期', trigger: 'change' }
                ],
                embryoNumber:[
                    { required: true, message: '请选择胎数', trigger: 'change' }
                ],
                height: [
                    { required: true, message: '当前身高', type:'number', trigger: 'blur' },
                ],
                weight: [
                    { required: true, message: '请输入当前体重', type:'number', trigger: 'blur' },
                ],
                pregnancyWeight: [
                    { required: true, message: '请输入孕前体重', type:'number', trigger: 'blur' },
                ],
            },//输入规则
            isEdit:false,//false 为编辑 true 为保存
            bloodTypeList:[//血型列表
                {
                    label:'A型',
                    value:1
                },
                {
                    label:'B型',
                    value:2
                },
                {
                    label:'AB型',
                    value:3
                },
                {
                    label:'O型',
                    value:4
                },
                {
                    label:'不清楚',
                    value:5
                },
            ],
            pregnancyStatusList:[//是否孕产妇
                {
                    label:'是',
                    value:1
                },
                {
                    label:'否',
                    value:2
                },
            ],
            labourTypeList:[//体力劳动等级
                {
                    label:'轻体力劳动',
                    value:1
                },
                {
                    label:'中等体力劳动',
                    value:2
                },
                {
                    label:'重体力劳动',
                    value:3
                },
                {
                    label:'极重体力劳动',
                    value:4
                },
            ],
            embryoNumberList:[//胎数
                 {
                    label:'单胎',
                    value:1
                },
                {
                    label:'双胎',
                    value:2
                },
                {
                    label:'多胎',
                    value:3
                },
            ],
            gestationalWeeksList:[],//孕周 
        }
    },
    created(){
        let arr = [];
        for(let i=1;i<=40;i++){
            if(i<=12){
                arr.push({
                    label:` ${i} ` + '[孕早期]',
                    value:i
                })
            }else if(i<=25){
                arr.push({
                    label:` ${i} ` + '[孕中期]',
                    value:i
                })
            }else{
                arr.push({
                    label:` ${i} ` + '[孕晚期]',
                    value:i
                })
            }
        }
        this.gestationalWeeksList = arr
    },   
    
    computed:{
        getUserDetailsData(){
            if(!this.userDetailsData) return false
            Object.keys(this.ruleForm).forEach(item=>{
                if(['height','weight','pregnancyWeight'].includes(item)) this.ruleForm[item] = this.userDetailsData[item] * 1 || ''
                else this.ruleForm[item] = this.userDetailsData[item] || ''
            })
            return this.ruleForm
        }
    },
    methods:{
        
        /**
         * @description: 保存按钮
         * @param {*}
         * @return {*}
         */    
        submitHandel(){
            if(this.isEdit){
                if(!this.ruleForm.bloodType) return this.$message.error('请选择血型');
                if(this.ruleForm.sex == 2){
                    if(!this.ruleForm.pregnancyStatus) return this.$message.error('请选择是否孕产妇');
                }
                if(!this.ruleForm.labour) return this.$message.error('请选择体力劳动等级');
               
                if(this.ruleForm.pregnancyStatus == 1){
                    if(!this.ruleForm.lastMenstrualPeriod) return this.$message.error('请选择末次月经时间')
                    if(!this.ruleForm.predictChildbirth) return this.$message.error('请选择预产期时间')
                    if(!this.ruleForm.embryoNumber) return this.$message.error('请选择胎数');
                }
                if(!this.ruleForm.weight) return this.$message.error('请输入当前体重');
                if(!this.ruleForm.height) return this.$message.error('请输入当前身高');
                if(this.ruleForm.pregnancyStatus == 1){
                    if(!this.ruleForm.gestationalWeeks) return this.$message.error('请选择孕周')
                    if(!this.ruleForm.pregnancyWeight) return this.$message.error('请输入孕前体重')
                }
                
                // delete this.ruleForm.address;
                UpdatepatientArchiesLeft(this.ruleForm).then(res=>{
                    if(res.code == 0 ){
                        this.$message.success('修改成功')
                        this.isEdit = false;
                        this.$emit('userEdit',true)
                    }else{
                        this.$message.error(res.message)
                    }
                })
            }
        }
    },
    filters:{
        gestationalWeeksFilts(value){
            if(value<=12){
                return ` ${value} `  + '[孕早期]'
            }else if(value <=25){
                return ` ${value} `  + '[孕中期]'
            }else{
                return ` ${value} `  + '[孕晚期]'
            }
        },
        bloodTypeFilt(value){
            switch(value * 1 ){
                case 1 : return 'A型' ;
                case 2 : return 'B型' ;
                case 3 : return 'AB型' ;
                case 4 : return 'O型' ;
                case 5 : return '不清楚' ;
                default : return ''
            }
        },
        labourFilte(value){
            switch(value * 1 ){
                case 1 : return '轻体力劳动' ;
                case 2 : return '中等体力劳动' ;
                case 3 : return '重体力劳动' ;
                case 4 : return '极重体力劳动' ;
                default : return ''
            }
        },
        embryoNumberFilte(value){
            switch(value * 1 ){
                case 1 : return '单胎' ;
                case 2 : return '双胎' ;
                case 3 : return '多胎' ;
                default : return ''
            }
        }
    }
}
</script>
<style scoped lang="less">
@import './index.less';
</style>